module.exports = __webpack_public_path__ + "img/HZ-P6009.20ebe2e6.png";